enum SocialLinkAlias {
  whatsApp = 'whatsApp',
  instagram = 'instagram',
  telegram = 'telegram',
  twitch = 'twitch',
  fansly = 'fansly',
  onlyFans = 'onlyFans',
  xTwitter = 'xTwitter',
  signal = 'signal',
}

export { SocialLinkAlias };
